"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { User } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const reasons = [{
  title: "Una conversazione, non un'intervista.",
  desc: "Niente domande preconfezionate. Niente copione. Solo il tuo punto di vista raccontato come viene naturale."
}, {
  title: "Pubblico che capisce.",
  desc: "CEO, marketers e creativi che cercano contenuti veri sulla comunicazione. Non follower generici."
}, {
  title: "Il contenuto non scompare.",
  desc: "Video YouTube, articolo blog, presenza sul sito. Non svanisce in 24 ore come una story."
}, {
  title: "Ti raccontiamo bene.",
  desc: "Un articolo, un video e una presenza pensati per valorizzare la tua storia non un copia-incolla."
}, {
  title: "Fai parte di qualcosa che cresce.",
  desc: "Lionia è giovane, multiculturale, in espansione. Entrarci adesso significa esserci dall'inizio."
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function ConcreteReasons() {
  return <section id="concretereasons" className="bg-background py-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6">
        
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 flex flex-col items-center justify-center text-center">
          <div className="mb-4 flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-muted-foreground">
            <span>PERCHÉ</span>
            <div className="size-1.5 rotate-45 bg-primary" />
            <span>PARTECIPARE</span>
          </div>
          <h2 className="font-default text-4xl font-bold tracking-tight text-foreground md:text-5xl text-center">
            Cinque motivi <span className="text-primary">concreti per partecipare.</span>
          </h2>
        </motion.div>

        
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5 items-stretch justify-center">
          {reasons.map((reason, i) => <motion.div key={i} data-index={i} variants={itemVariants} className="h-full">
              <Card className="group flex h-full w-full flex-col items-start justify-start border-border bg-card p-6 text-left shadow-sm rounded-lg transition-all duration-300 hover:border-primary">
                <CardHeader className="w-full pb-3 px-0">
                  <CardTitle className="font-default text-lg font-bold leading-snug text-card-foreground text-left">
                    {reason.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="w-full px-0">
                  <p className="text-sm leading-relaxed text-muted-foreground text-left">
                    {reason.desc}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </motion.div>

        
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-20 flex flex-col items-center justify-center gap-4 py-8">
          <div className="flex size-12 shrink-0 items-center justify-center rounded-lg border border-border bg-card text-muted-foreground">
            <User className="size-6" />
          </div>
          <div className="flex flex-col items-center justify-center text-center font-serif text-lg font-medium italic text-primary">
            <div className="flex flex-wrap items-center justify-center gap-2">
              <span>&quot;Non cerchi pubblicità, cerchi una conversazione autentica.&quot;</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}